export default __webpack_public_path__ + "images/pictograms/digital-print.svg?f3d03c505649b8485e10111d1b568e553fa317e63b234add210a85cef8adc084";